import { SortDirection, TableSort } from "@redotech/redo-views-common/table";

export const SHORTAGE_COLUMN_KEY = "shortage";

/**
 * Units that must be built before every committed order can ship. Available is
 * physical only (on hand minus committed and unavailable), so a negative
 * available is exactly the amount owed.
 */
export function shortageFromAvailable(available: number): number {
  return Math.max(0, -available);
}

export interface InventoryLevelsSortRequest {
  sortBy: string | undefined;
  sortDirection: "asc" | "desc" | undefined;
}

/**
 * Shortage has no index field of its own: it is derived from available, so
 * sorting by shortage is sorting by available in the opposite direction.
 */
export function inventoryLevelsSortRequest(
  sort: TableSort | undefined,
): InventoryLevelsSortRequest {
  if (!sort) {
    return { sortBy: undefined, sortDirection: undefined };
  }

  const ascending = sort.direction === SortDirection.ASC;
  if (sort.key === SHORTAGE_COLUMN_KEY) {
    return {
      sortBy: "totalAvailable",
      sortDirection: ascending ? "desc" : "asc",
    };
  }

  return { sortBy: sort.key, sortDirection: ascending ? "asc" : "desc" };
}
